/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const PROFILE_API_BASE_URL = new InjectionToken<string>('PROFILE_API_BASE_URL');

@Injectable()
export class ProfileAppService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROFILE_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param studentId (optional) 
     * @return Success
     */
    getStudentProfile(studentId: number | undefined): Observable<GetStudentProfileResponse> {
        let url_ = this.baseUrl + "/api/workbook/profile/profile/get-student-profile?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentProfile(<any>response_);
                } catch (e) {
                    return <Observable<GetStudentProfileResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetStudentProfileResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetStudentProfile(response: HttpResponseBase): Observable<GetStudentProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStudentProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStudentProfileResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveStudentAvatar(body: SaveStudentAvatarRequest | undefined): Observable<SaveStudentAvatarResponse> {
        let url_ = this.baseUrl + "/api/workbook/profile/profile/save-student-avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json;odata.metadata=minimal;odata.streaming=true",
                "Accept": "application/json;odata.metadata=minimal;odata.streaming=true"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveStudentAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveStudentAvatar(<any>response_);
                } catch (e) {
                    return <Observable<SaveStudentAvatarResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<SaveStudentAvatarResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSaveStudentAvatar(response: HttpResponseBase): Observable<SaveStudentAvatarResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveStudentAvatarResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SaveStudentAvatarResponse>(<any>null);
    }
}

export enum AccessModeKind {
    Preview = <any>"Preview",
    Full = <any>"Full",
}

export enum SubscriptionStatusKind {
    Active = <any>"Active",
    Trial = <any>"Trial",
    TrialExpired = <any>"TrialExpired",
    Expired = <any>"Expired",
    Cancelled = <any>"Cancelled",
    InActive = <any>"InActive",
    Completed = <any>"Completed",
    Preview = <any>"Preview",
}

export enum RunStatus {
    Scheduled = <any>"Scheduled",
    Started = <any>"Started",
    Completed = <any>"Completed",
}

export class MediaFieldBaseOfImageField implements IMediaFieldBaseOfImageField {
    id: number;
    url: string | undefined;
    readonly hasValue: boolean;

    protected _discriminator: string;

    constructor(data?: IMediaFieldBaseOfImageField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "MediaFieldBaseOfImageField";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            (<any>this).hasValue = _data["hasValue"];
        }
    }

    static fromJS(data: any): MediaFieldBaseOfImageField {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ImageField") {
            let result = new ImageField();
            result.init(data);
            return result;
        }
        let result = new MediaFieldBaseOfImageField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator; 
        data["id"] = this.id;
        data["url"] = this.url;
        data["hasValue"] = this.hasValue;
        return data; 
    }

    clone(): MediaFieldBaseOfImageField {
        const json = this.toJSON();
        let result = new MediaFieldBaseOfImageField();
        result.init(json);
        return result;
    }
}

export interface IMediaFieldBaseOfImageField {
    id: number;
    url: string | undefined;
    hasValue: boolean;
}

export class ImageField extends MediaFieldBaseOfImageField implements IImageField {

    constructor(data?: IImageField) {
        super(data);
        this._discriminator = "ImageField";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ImageField {
        data = typeof data === 'object' ? data : {};
        let result = new ImageField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }

    clone(): ImageField {
        const json = this.toJSON();
        let result = new ImageField();
        result.init(json);
        return result;
    }
}

export interface IImageField extends IMediaFieldBaseOfImageField {
}

export class SubjectDto implements ISubjectDto {
    name: string | undefined;
    description: string | undefined;
    previewImage: ImageField;
    iconImage: ImageField;
    tenantId: number;
    id: number;

    constructor(data?: ISubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.previewImage = _data["previewImage"] ? ImageField.fromJS(_data["previewImage"]) : <any>undefined;
            this.iconImage = _data["iconImage"] ? ImageField.fromJS(_data["iconImage"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["previewImage"] = this.previewImage ? this.previewImage.toJSON() : <any>undefined;
        data["iconImage"] = this.iconImage ? this.iconImage.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }

    clone(): SubjectDto {
        const json = this.toJSON();
        let result = new SubjectDto();
        result.init(json);
        return result;
    }
}

export interface ISubjectDto {
    name: string | undefined;
    description: string | undefined;
    previewImage: ImageField;
    iconImage: ImageField;
    tenantId: number;
    id: number;
}

export class StudentEnrollmentDto implements IStudentEnrollmentDto {
    courseId: number;
    course: string | undefined;
    studentId: number;
    accessLevelId: number;
    accessLevel: string | undefined;
    accessMode: AccessModeKind;
    parentUserId: number;
    isTrial: boolean;
    subscriptionTermStartDate: moment.Moment;
    subscriptionTermEndDate: moment.Moment | undefined;
    subscriptionStatus: SubscriptionStatusKind;
    grade: string | undefined;
    courseStartDate: moment.Moment | undefined;
    courseEndDate: moment.Moment | undefined;
    isCourseActive: boolean;
    courseRunStatus: RunStatus;
    subjects: SubjectDto[] | undefined;
    id: string;

    constructor(data?: IStudentEnrollmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.course = _data["course"];
            this.studentId = _data["studentId"];
            this.accessLevelId = _data["accessLevelId"];
            this.accessLevel = _data["accessLevel"];
            this.accessMode = _data["accessMode"];
            this.parentUserId = _data["parentUserId"];
            this.isTrial = _data["isTrial"];
            this.subscriptionTermStartDate = _data["subscriptionTermStartDate"] ? moment(_data["subscriptionTermStartDate"].toString()) : <any>undefined;
            this.subscriptionTermEndDate = _data["subscriptionTermEndDate"] ? moment(_data["subscriptionTermEndDate"].toString()) : <any>undefined;
            this.subscriptionStatus = _data["subscriptionStatus"];
            this.grade = _data["grade"];
            this.courseStartDate = _data["courseStartDate"] ? moment(_data["courseStartDate"].toString()) : <any>undefined;
            this.courseEndDate = _data["courseEndDate"] ? moment(_data["courseEndDate"].toString()) : <any>undefined;
            this.isCourseActive = _data["isCourseActive"];
            this.courseRunStatus = _data["courseRunStatus"];
            if (Array.isArray(_data["subjects"])) {
                this.subjects = [] as any;
                for (let item of _data["subjects"])
                    this.subjects.push(SubjectDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StudentEnrollmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentEnrollmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["course"] = this.course;
        data["studentId"] = this.studentId;
        data["accessLevelId"] = this.accessLevelId;
        data["accessLevel"] = this.accessLevel;
        data["accessMode"] = this.accessMode;
        data["parentUserId"] = this.parentUserId;
        data["isTrial"] = this.isTrial;
        data["subscriptionTermStartDate"] = this.subscriptionTermStartDate ? this.subscriptionTermStartDate.toISOString() : <any>undefined;
        data["subscriptionTermEndDate"] = this.subscriptionTermEndDate ? this.subscriptionTermEndDate.toISOString() : <any>undefined;
        data["subscriptionStatus"] = this.subscriptionStatus;
        data["grade"] = this.grade;
        data["courseStartDate"] = this.courseStartDate ? this.courseStartDate.toISOString() : <any>undefined;
        data["courseEndDate"] = this.courseEndDate ? this.courseEndDate.toISOString() : <any>undefined;
        data["isCourseActive"] = this.isCourseActive;
        data["courseRunStatus"] = this.courseRunStatus;
        if (Array.isArray(this.subjects)) {
            data["subjects"] = [];
            for (let item of this.subjects)
                data["subjects"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): StudentEnrollmentDto {
        const json = this.toJSON();
        let result = new StudentEnrollmentDto();
        result.init(json);
        return result;
    }
}

export interface IStudentEnrollmentDto {
    courseId: number;
    course: string | undefined;
    studentId: number;
    accessLevelId: number;
    accessLevel: string | undefined;
    accessMode: AccessModeKind;
    parentUserId: number;
    isTrial: boolean;
    subscriptionTermStartDate: moment.Moment;
    subscriptionTermEndDate: moment.Moment | undefined;
    subscriptionStatus: SubscriptionStatusKind;
    grade: string | undefined;
    courseStartDate: moment.Moment | undefined;
    courseEndDate: moment.Moment | undefined;
    isCourseActive: boolean;
    courseRunStatus: RunStatus;
    subjects: SubjectDto[] | undefined;
    id: string;
}

export class StudentProfileDto implements IStudentProfileDto {
    fullName: string | undefined;
    username: string | undefined;
    avatarImageId: number;
    avatarImageUrl: string | undefined;
    pointsEarned: number;
    awardsEarned: number;
    currentEnrollment: StudentEnrollmentDto;
    id: number;

    constructor(data?: IStudentProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.username = _data["username"];
            this.avatarImageId = _data["avatarImageId"];
            this.avatarImageUrl = _data["avatarImageUrl"];
            this.pointsEarned = _data["pointsEarned"];
            this.awardsEarned = _data["awardsEarned"];
            this.currentEnrollment = _data["currentEnrollment"] ? StudentEnrollmentDto.fromJS(_data["currentEnrollment"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StudentProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["username"] = this.username;
        data["avatarImageId"] = this.avatarImageId;
        data["avatarImageUrl"] = this.avatarImageUrl;
        data["pointsEarned"] = this.pointsEarned;
        data["awardsEarned"] = this.awardsEarned;
        data["currentEnrollment"] = this.currentEnrollment ? this.currentEnrollment.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): StudentProfileDto {
        const json = this.toJSON();
        let result = new StudentProfileDto();
        result.init(json);
        return result;
    }
}

export interface IStudentProfileDto {
    fullName: string | undefined;
    username: string | undefined;
    avatarImageId: number;
    avatarImageUrl: string | undefined;
    pointsEarned: number;
    awardsEarned: number;
    currentEnrollment: StudentEnrollmentDto;
    id: number;
}

export class StudentAwardDto implements IStudentAwardDto {
    courseId: number;
    awardType: string | undefined;
    awardDate: moment.Moment;
    awardImageUrl: string | undefined;
    awardImageId: number;
    awardTitle: string | undefined;
    lessonTitle: string | undefined;
    lessonType: string | undefined;
    subject: string | undefined;
    reason: string | undefined;
    learningActivityId: number;

    constructor(data?: IStudentAwardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.courseId = _data["courseId"];
            this.awardType = _data["awardType"];
            this.awardDate = _data["awardDate"] ? moment(_data["awardDate"].toString()) : <any>undefined;
            this.awardImageUrl = _data["awardImageUrl"];
            this.awardImageId = _data["awardImageId"];
            this.awardTitle = _data["awardTitle"];
            this.lessonTitle = _data["lessonTitle"];
            this.lessonType = _data["lessonType"];
            this.subject = _data["subject"];
            this.reason = _data["reason"];
            this.learningActivityId = _data["learningActivityId"];
        }
    }

    static fromJS(data: any): StudentAwardDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentAwardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["courseId"] = this.courseId;
        data["awardType"] = this.awardType;
        data["awardDate"] = this.awardDate ? this.awardDate.toISOString() : <any>undefined;
        data["awardImageUrl"] = this.awardImageUrl;
        data["awardImageId"] = this.awardImageId;
        data["awardTitle"] = this.awardTitle;
        data["lessonTitle"] = this.lessonTitle;
        data["lessonType"] = this.lessonType;
        data["subject"] = this.subject;
        data["reason"] = this.reason;
        data["learningActivityId"] = this.learningActivityId;
        return data; 
    }

    clone(): StudentAwardDto {
        const json = this.toJSON();
        let result = new StudentAwardDto();
        result.init(json);
        return result;
    }
}

export interface IStudentAwardDto {
    courseId: number;
    awardType: string | undefined;
    awardDate: moment.Moment;
    awardImageUrl: string | undefined;
    awardImageId: number;
    awardTitle: string | undefined;
    lessonTitle: string | undefined;
    lessonType: string | undefined;
    subject: string | undefined;
    reason: string | undefined;
    learningActivityId: number;
}

export class GetStudentProfileResponse implements IGetStudentProfileResponse {
    profile: StudentProfileDto;
    awards: StudentAwardDto[] | undefined;

    constructor(data?: IGetStudentProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"] ? StudentProfileDto.fromJS(_data["profile"]) : <any>undefined;
            if (Array.isArray(_data["awards"])) {
                this.awards = [] as any;
                for (let item of _data["awards"])
                    this.awards.push(StudentAwardDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetStudentProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        if (Array.isArray(this.awards)) {
            data["awards"] = [];
            for (let item of this.awards)
                data["awards"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetStudentProfileResponse {
        const json = this.toJSON();
        let result = new GetStudentProfileResponse();
        result.init(json);
        return result;
    }
}

export interface IGetStudentProfileResponse {
    profile: StudentProfileDto;
    awards: StudentAwardDto[] | undefined;
}

export class SaveStudentAvatarRequest implements ISaveStudentAvatarRequest {
    imgData: string | undefined;
    title: string | undefined;

    constructor(data?: ISaveStudentAvatarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imgData = _data["imgData"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): SaveStudentAvatarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStudentAvatarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imgData"] = this.imgData;
        data["title"] = this.title;
        return data; 
    }

    clone(): SaveStudentAvatarRequest {
        const json = this.toJSON();
        let result = new SaveStudentAvatarRequest();
        result.init(json);
        return result;
    }
}

export interface ISaveStudentAvatarRequest {
    imgData: string | undefined;
    title: string | undefined;
}

export class SaveStudentAvatarResponse implements ISaveStudentAvatarResponse {
    message: string | undefined;
    imageId: number;
    imageUrl: string | undefined;

    constructor(data?: ISaveStudentAvatarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.imageId = _data["imageId"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): SaveStudentAvatarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveStudentAvatarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["imageId"] = this.imageId;
        data["imageUrl"] = this.imageUrl;
        return data; 
    }

    clone(): SaveStudentAvatarResponse {
        const json = this.toJSON();
        let result = new SaveStudentAvatarResponse();
        result.init(json);
        return result;
    }
}

export interface ISaveStudentAvatarResponse {
    message: string | undefined;
    imageId: number;
    imageUrl: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}